
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { useIsMobile } from '@/hooks/use-mobile';

interface TableObservationsDialogProps {
  tableId: string;
  observations: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (tableId: string, observations: string) => void;
}

const TableObservationsDialog: React.FC<TableObservationsDialogProps> = ({
  tableId,
  observations,
  open,
  onOpenChange,
  onSave
}) => {
  const [observationText, setObservationText] = useState(observations || '');
  const isMobile = useIsMobile();
  
  const handleSave = () => {
    onSave(tableId, observationText);
    onOpenChange(false);
  };
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={isMobile ? "w-[90vw] max-w-[90vw] p-4" : ""}>
        <DialogHeader>
          <DialogTitle>Observações da Mesa</DialogTitle>
          <DialogDescription>
            Adicione observações importantes sobre esta mesa.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-2">
          <div className="grid gap-2">
            <Label htmlFor="observations">Observações</Label>
            <Textarea
              id="observations"
              placeholder="Digite as observações aqui..."
              value={observationText}
              onChange={(e) => setObservationText(e.target.value)}
              className="min-h-[150px]"
            />
          </div>
        </div>
        
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSave}
          >
            Salvar Observações
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TableObservationsDialog;
